import { useTranslation } from "react-i18next";
import { CustomIcon } from "components/icon/customIcon.component";
import { ColorV2 } from "config/colors";
import { formatNumber } from "utils/utils";
import { formatHours, formatReportDate } from "../logic/tips.format.logic";
import {
  getStatusLabel,
  getStatusVariant,
} from "./tips.monthlyReports.logic";
import type { MonthlyReportDetail } from "./tips.monthlyReports.logic";
import {
  MonthlyDetails,
  MonthlyDetailsHeader,
  MonthlyDetailsRow,
  MonthlyStatusPill,
} from "./tips.monthlyReports.styled";

interface MonthlyReportDetailsProps {
  readonly details: readonly MonthlyReportDetail[];
  readonly hourLabel: string;
  readonly locale: string;
  readonly minuteLabel: string;
}

export const MonthlyReportDetails = (
  props: MonthlyReportDetailsProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <MonthlyDetails>
      <MonthlyDetailsHeader>
        <div>{t("MonthlyTipReport.Date")}</div>
        <div>{t("MonthlyTipReport.Unit")}</div>
        <div>{t("MonthlyTipReport.Hours")}</div>
        <div>{t("MonthlyTipReport.Amount")}</div>
        <div>{t("MonthlyTipReport.Status")}</div>
      </MonthlyDetailsHeader>
      {props.details.map((detail) => (
        <MonthlyDetailsRow key={detail.id}>
          <div>
            {formatReportDate({
              dateValue: detail.date,
              locale: props.locale,
            })}
          </div>
          <div>{detail.unit ?? t("MonthlyTipReport.UnitPlaceholder")}</div>
          <div>
            {formatHours({
              hourLabel: props.hourLabel,
              hours: detail.hours,
              minuteLabel: props.minuteLabel,
            })}
          </div>
          <div>
            {formatNumber(detail.amount)} {t("Tips.Currency")}
          </div>
          <div>
            <MonthlyStatusPill $variant={getStatusVariant(detail.status)}>
              {detail.status !== "none" && (
                <CustomIcon
                  name="v2/small-checkmark"
                  size="18px"
                  color={
                    detail.status === "distributed"
                      ? ColorV2.Blue4
                      : ColorV2.PositiveGreen
                  }
                />
              )}
              {getStatusLabel({ status: detail.status, t })}
            </MonthlyStatusPill>
          </div>
        </MonthlyDetailsRow>
      ))}
    </MonthlyDetails>
  );
};
